var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertiesManagment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4211",
    "data-name": "Group 4211",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.6,
    height: 23.5,
    viewBox: "0 0 27.6 23.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1651",
    "data-name": "Rectangle 1651",
    width: 27.6,
    height: 23.5,
    fill: "#6a707e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3700",
    "data-name": "Group 3700",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14147",
    "data-name": "Path 14147",
    d: "M27.6,76.524H0V75.146H2.784v-.328q0-8.3-.005-16.606c0-.205.052-.285.306-.32,2.321-.32,4.639-.653,6.959-.983L13,56.49V75.132h1.614v-15.4h10.2V75.149H27.6ZM6.727,73.186H9.06v1.94h1.594V71.8H5.129v3.323h1.6ZM10.7,58.359H9.014V59.7H10.7Zm0,10.084H9.019V69.8H10.7ZM16.9,69.8h1.687V68.443H16.9ZM18.581,71.8H16.9v1.357h1.682Zm3.947,0H20.844v1.349h1.685ZM6.757,61.717H5.083v1.352H6.757Zm2.259,1.35H10.7V61.718H9.016Zm9.571-1.347H16.9V63.07h1.689Zm2.254,1.346h1.677V61.714H20.841ZM6.758,65.086H5.073v1.349H6.758Zm3.948,0H9.018v1.345h1.688Zm7.873,0H16.9v1.346h1.681Zm2.264,1.344h1.673V65.082H20.844ZM5.069,69.793H6.762V68.45H5.069Zm17.458-1.344H20.841V69.8h1.686Z",
    transform: "translate(0 -53.024)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14148",
    "data-name": "Path 14148",
    d: "M66.071,3.219V0H72.33V1.422a6.122,6.122,0,0,0,0,.642c.023.216-.055.3-.319.337-1.957.267-3.912.548-5.867.824a.462.462,0,0,1-.078-.007",
    transform: "translate(-61.313 0.001)",
    fill: "#6a707e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertiesManagment);
export default __webpack_public_path__ + "static/media/PropertiesManagment.59b264ef4036108dc894946514dd9af3.svg";
export { ForwardRef as ReactComponent };